<template>
  <div
    v-show="alertActive"
    class="alert"
    role="banner"
    :class="`alert--${theme} alert--${position}`"
  >
    <div class="alert__content">
      <div class="alert__text">
        <slot></slot>
      </div>
      <button
        class="alert__button button"
        :class="buttonText ? 'alert__button--text' : 'alert__button--icon'"
        v-on:click="handleClose"
      >
        <span v-if="!buttonText" class="alert__close-icon" title="Close"></span>
        <span v-if="buttonText" class="alert__close-text">{{
          buttonText
        }}</span>
      </button>
    </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'ahc-alert',
    props: {
      theme: {
        type: String,
        required: true
      },
      buttonText: {
        type: String,
        default: null
      },
      position: {
        type: String,
        default: "top"
      },
      storage: {
        type: Number,
        default: 0
      },
    },
    computed: {
      alertActive() {
        return (this.position === 'bottom')
          ? this.$store.state.bottomAlertActive
          : this.$store.state.topAlertActive
      }
    },
    mounted () {
      this.checkAlert();
    },
    methods: {
      handleClose() {
        this.deactivateAlert();

        //if storage is greater than zero, set storage as hours in localStorage, else set session storage
        if (this.storage > 0) {
          this.setAlertSleep();
        } else {
          this.setAlertSession();
        }
      },
      setAlertSleep() {
        const dt = new Date();
        // set time for based on storage prop
        dt.setHours(dt.getHours() + this.storage);
        localStorage.setItem('ahc-alert-sleep', dt);
      },
      setAlertSession() {
        sessionStorage.setItem('ahc-alert-session', 1);
      },
      checkAlert() {
        if (this.storage > 0) {
          this.checkAlertSleep();
        } else {
          this.checkAlertSession();
        }
      },
      checkAlertSleep() {
        const now = new Date();
        const sleepTime = new Date(localStorage.getItem('ahc-alert-sleep'));

        // if the current time is greater than what's in localstorage, show the alert
        if (now.getTime() > sleepTime.getTime()) {
          this.activateAlert();
        }
      },
      checkAlertSession() {
        const session = sessionStorage.getItem('ahc-alert-session');

        if (session != 1) {
          this.activateAlert();
        }

      },
      activateAlert() {
        const mutation = (this.position === 'bottom')
          ? 'setBottomAlertActive'
          : 'setTopAlertActive';

        this.$store.commit(mutation, true);
      },
      deactivateAlert() {
        const mutation = (this.position === 'bottom')
          ? 'setBottomAlertActive'
          : 'setTopAlertActive';

        this.$store.commit(mutation, false);
      }
    },
}
</script>

<style lang="scss">
@import "alert";
</style>
